//import * as React from 'react';
import React from "react";

//import InputLabel from '@mui/material/InputLabel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { convertAmount } from './utils';
import { calculateGainLoss } from './gainloss';
import Grid from '@mui/material/Grid';
//import FormControl from '@mui/material/FormControl';
//import Button from '@mui/material/Button';
//import TextField from '@mui/material/TextField';
//import OpeningBalance from './openingBalance';
//import AddDynamicInputFields from "./openingBalance.orig"

// Date, Description, FoCurrency, Rate, FuCurrency

export default function GlTransactions({ data, basis, ob = [] }) {

    // now calculate the gain/loss
    // OB entries are pre-merged into data by handleRates (FIFO approach).
    var [glData, closingBalance] = calculateGainLoss(data, []);

    if (!data) {
        return false;
    }

    const isObRow = (row) => /^\d+$/.test(String(row.date));
    const txRows = glData.filter(row => !isObRow(row)).sort((a, b) => new Date(b.date) - new Date(a.date));
    
    // OB rows are sorted by numeric index descending so "0" is at the very end
    const obRows = glData.filter(row => isObRow(row));
    obRows.sort((a, b) => parseInt(b.date) - parseInt(a.date));
    
    const displayData = [...txRows, ...obRows];
    
    // Sort closing balance newest-to-oldest too
    const sortedClosingBalance = [...closingBalance].sort((a, b) => new Date(b[0]) - new Date(a[0]));

    return (
        <React.Fragment>
            {/*
            <Grid container sx={{
                mt: 1, borderStyle: 'solid', borderWidth:
                    '1px', borderRadius: '4px', borderColor: 'lightgray'
            }}>
            </Grid> */ }
            <TableContainer component={Paper}>
                <Grid item sx={{
                    mt: 1, borderStyle: 'solid', borderWidth:
                        '1px', borderRadius: '4px', borderColor: 'lightgray'
                }} >
                    <b>&nbsp;&nbsp;Closing Balance</b>
                    <Table size="small" aria-label="a dense table" id="closing-balance">
                        <TableHead>
                            <TableRow >
                                <TableCell align="left"><b>Date</b></TableCell>
                                <TableCell align="left"><b>Description</b></TableCell>
                                <TableCell align="right"><b>{basis.foreign_currency}</b></TableCell>
                                <TableCell align="right"><b>Rate</b></TableCell>
                                <TableCell align="right"><b>{basis.functional_currency}</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedClosingBalance.map((row) => (
                                <TableRow
                                    key={row.join('|')}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell align="left">{row[0]}</TableCell>
                                    <TableCell align="left">{row[1]}</TableCell>
                                    <TableCell align="right">{convertAmount(row[2], 2)}</TableCell>
                                    <TableCell align="right">{convertAmount(row[3], 6)}</TableCell>
                                    <TableCell align="right">{convertAmount(row[4], 6)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
                <Table size="small" aria-label="a dense table" id="gl-transactions">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left"><b>Date</b></TableCell>
                            <TableCell align="left"><b>Description</b></TableCell>
                            <TableCell align="right"><b>{basis.foreign_currency}</b></TableCell>
                            <TableCell align="right"><b>{basis.functional_currency}</b></TableCell>
                            <TableCell align="right"><b>Fx Gain/Loss</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayData.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                { /*<TableCell component="th" scope="row">
                                {row.date}
                                </TableCell> */ }
                                <TableCell align="left">{row.date}</TableCell>
                                <TableCell align="left">{row.description}</TableCell>
                                <TableCell align="right">{convertAmount(row.amount, 2)}</TableCell>
                                <TableCell align="right">{convertAmount(row.functional_amount, 6)}</TableCell>
                                <TableCell align="right">{convertAmount(row.gainloss, 6)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <br></br>
        </React.Fragment>
    );
}
